
const wcProductPriceTypeTooltip = {
	init: function () {
		const self = this;

		if (!jQuery('.single-product').length) {
			return false;
		}

		if (typeof acfDataPriceLabels == 'undefined') {
			return false;
		}

		self.createTooltips();
		self.createTooltipsForSelectBox();
	},

	createTooltips: function () {
		const self = this;

		//acfDataPriceLabels is the global variable from php method PHEU\ACF->acf_data_price_labels
		for (const key in acfDataPriceLabels.labels) {
			if (acfDataPriceLabels.labels.hasOwnProperty(key)) {
				// console.log(`Key: ${key}, Value: ${acfDataPriceLabels.labels[key]}`);

				const radio = jQuery('.variable-item-radio-input-wrapper input[type="radio"][data-value="' + key + '"], .individual-radio-boxes input[type="radio"][value="' + key + '"]'); //two types on different product pages

				if (!radio.length) {
					continue;
				}

				const tooltip = jQuery('<div class="variable-tooltip-description"></div>').text(acfDataPriceLabels.labels[key]);

				// Add the tooltip to the DOM
				if (!radio.closest(".individual-radio-boxes").length) {
					radio.parent().append(tooltip);
					tooltip.addClass("--inline");
				} else {
					radio.closest(".individual-radio-boxes").append(tooltip);
				}

				let toolboxTrigger = radio.parent().children(".variable-item-radio-value-wrapper");
				if (!toolboxTrigger.length) {
					toolboxTrigger = radio.parent().children("span");
				}

				self.setTooltipHoverEvents(tooltip, toolboxTrigger);

				//Add symbol for tooltip triggered text

				let radioLabelText = radio.parent().find(".variable-item-radio-value");
				if (!radioLabelText.length) {
					radioLabelText = radio.parent().children("span");
				}

				radioLabelText
					.append(' <span class="variable-tooltip-info-symbol"></span>');
			}
		}
	},

	createTooltipsForSelectBox: function() {
		const self = this;

		jQuery('.variations .value select').each(function() {
			if (jQuery(this).css("display") == "none") {
				return;
			}

			jQuery(this).after('<span class="variable-tooltip-info-symbol --margin-left d-none"></span>');
			const tooltip = jQuery('<div class="variable-tooltip-description --margin-top"></div>');
			jQuery(this).parent().append(tooltip);
		});

		jQuery('.variations .value select').on("change", function() {
			if (jQuery(this).css("display") == "none") {
				return;
			}

			const selectbox = jQuery(this);
			const selected_value = selectbox.val();

			//hide showed tooltips
			selectbox
				.parent()
					.children(".variable-tooltip-info-symbol")
						.addClass("d-none");

			//acfDataPriceLabels is the global variable from php method PHEU\ACF->acf_data_price_labels
			for (const key in acfDataPriceLabels.labels) {
				if (acfDataPriceLabels.labels.hasOwnProperty(key) && key === selected_value) {
					selectbox
						.parent()
							.children(".variable-tooltip-info-symbol")
								.removeClass("d-none");

					selectbox
						.parent()
							.children(".variable-tooltip-description")
								.text(acfDataPriceLabels.labels[key]);

					//tooltips events
					self.setTooltipHoverEvents(
						selectbox.parent().children(".variable-tooltip-description"),
						selectbox.parent().children(".variable-tooltip-info-symbol")
					)
				}
			}
		});
	},

	setTooltipHoverEvents: function(jquery_tooltip, jquery_trigger) {
		const self = this;

		const isTouchable = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

		jquery_trigger.off("mouseenter mouseleave click"); //reset
		jquery_tooltip.off("click"); //reset

		if (!isTouchable) {
			jquery_trigger
				.on("mouseenter", function (event) {
					jquery_tooltip.addClass("--show");
				})
				.on("mouseleave", function () {
					jquery_tooltip.removeClass("--show"); // Hide on mouse leave
				});
		} else {
			//Different approach for touch devices
			jquery_trigger
				.on("click", function (event) {
					if (!event.target.parentElement.classList.contains("variable-tooltip-info-symbol")) {
						return; //on touch devices, only allow mouse enter on variable-tooltip-info-symbol
					}

					if (event.target.parentElement.classList.contains("variable-tooltip-info-symbol") && jquery_tooltip.hasClass("--show")) {
						jquery_tooltip.removeClass("--show"); //for the second click it hides on touch devices
						return;
					}

					jquery_tooltip.addClass("--show");
				});
			jquery_tooltip
				.on("click", function (event) {
					jquery_tooltip.removeClass("--show");
				});
		}
	},
};

export { wcProductPriceTypeTooltip };